import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import HowItWorks from "@/sections/HowItWorks";
import WhoWeAre from "@/sections/WhoWeAre";
import WhatWeDo from "@/sections/WhatWeDo";
import TheHub from "@/sections/TheHub";
import Footer from "@/sections/Footer";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen overflow-x-hidden bg-brand-black text-white selection:bg-brand-gold/40"
    >
      {/* Global ambient backdrop */}
      <div className="pointer-events-none fixed inset-0 z-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_10%,rgba(176,38,255,0.10),transparent_45%),radial-gradient(circle_at_85%_85%,rgba(0,240,255,0.08),transparent_50%),radial-gradient(circle_at_50%_50%,rgba(212,175,55,0.05),transparent_55%)]" />
        <div className="absolute inset-0 bg-grid-faint [background-size:48px_48px] opacity-[0.35]" />
        <div className="absolute inset-0 scanline-bg opacity-30" />
      </div>

      <div className="relative z-10">
        <Navbar />
        <Hero />
        <HowItWorks />
        <WhoWeAre />
        <WhatWeDo />
        <TheHub />
        <Footer />
      </div>
    </main>
  );
}
